import { gql, useMutation } from 'urql';

const ADD_EMPLOYEES_TO_CATEGORY = gql`
  mutation ($categoryId: Int!, $employeeIds: [Int!]!, $guestsData: [ExternalParticipant!]!) {
    addParticipantsToCategory(
      input: { categoryId: $categoryId, participantIds: $employeeIds, guestsData: $guestsData }
    ) {
      total
      countWithoutSegment
      success
    }
  }
`;

interface AddParticipantsToCategoryResponse {
  addParticipantsToCategory: {
    total: number;
    countWithoutSegment: number;
    success: boolean;
  };
}

export interface GuestsData {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export interface GuestsDataRaw {
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
}

interface AddParticipantsToCategoryVariables {
  categoryId: number;
  employeeIds: number[];
  guestsData: GuestsData[];
}

export const useAddParticipantsToCategory = () => {
  return useMutation<AddParticipantsToCategoryResponse, AddParticipantsToCategoryVariables>(ADD_EMPLOYEES_TO_CATEGORY);
};
